import React from 'react';
import {
  Stack,
  Button,
  IconButton,
  Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../contexts/MemberContext';
import CompanyLogo from './CompanyLogo';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';

/**
 * Cashier Header Component
 * Shared header for all cashier pages with logout, company logo, and member page
 */
const CashierHeader = () => {
  const navigate = useNavigate();
  const { setOrientation } = useMember();

  // Handle navigation back to home
  const handleHomeClick = () => {
    navigate('/landing');
  };

  // Handle logout (flip to cashier login)
  const handlePersonClick = () => {
    setOrientation(1); // Flip orientation to show cashier login
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ mb: 2, maxWidth: '1200px', width: '100%', padding: '0 24px' }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={handleHomeClick}
        startIcon={<LogoutIcon />}
        size="medium"
      >
        Log Out
      </Button>

      <CompanyLogo />

      <Box sx={{ width: '121.81px', textAlign: 'right' }}>
        <IconButton
          onClick={handlePersonClick}
          color="text.secondary"
          aria-label="cashier login"
          size="large"
        >
          <PersonIcon fontSize="large" />
        </IconButton>
      </Box>
    </Stack >
  );
};

export default CashierHeader;